import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

import history from './history';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './Reducers/index';

import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense("ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ==");
const store = createStore(rootReducer, applyMiddleware(thunk));



 
ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
      <NotificationContainer />
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
